import React, { useEffect, useState } from "react";
import { ImageOff } from "lucide-react";

import { api } from "@/lib/api";
import { Skeleton } from "@/components/ui/skeleton";

export function GalleryImage({ media, alt, errorLabel, className = "" }) {
  const [source, setSource] = useState(media?.file_id ? "" : (media?.url || ""));
  const [loading, setLoading] = useState(Boolean(media?.file_id));
  const [failed, setFailed] = useState(false);

  useEffect(() => {
    if (!media?.file_id) {
      setSource(media?.url || "");
      setLoading(false);
      setFailed(false);
      return undefined;
    }

    const controller = new AbortController();
    let objectUrl = "";
    setSource("");
    setLoading(true);
    setFailed(false);
    api.get(`/gallery/media/${encodeURIComponent(media.id)}/content`, {
      responseType: "blob",
      signal: controller.signal,
    }).then((response) => {
      objectUrl = URL.createObjectURL(response.data);
      setSource(objectUrl);
    }).catch((error) => {
      if (error?.code !== "ERR_CANCELED") setFailed(true);
    }).finally(() => setLoading(false));

    return () => {
      controller.abort();
      if (objectUrl) URL.revokeObjectURL(objectUrl);
    };
  }, [media?.file_id, media?.id, media?.url]);

  if (loading) {
    return <Skeleton className={`aspect-video w-full ${className}`} data-testid={`gallery-media-loading-${media?.id}`} />;
  }
  if (failed || !source) {
    return (
      <div
        className={`aspect-video w-full bg-[var(--subtle-bg)] text-[var(--text-muted)] flex items-center justify-center ${className}`}
        role="alert"
        data-testid={`gallery-media-error-${media?.id}`}
      >
        <ImageOff className="h-6 w-6" aria-hidden="true" />
        <span className="sr-only">{errorLabel}</span>
      </div>
    );
  }
  return <img src={source} alt={alt} loading="lazy" className={className} />;
}
